import { render } from "./Testing.vue?vue&type=template&id=19722a44&scoped=true&ts=true"
import script from "./Testing.vue?vue&type=script&lang=ts"
export * from "./Testing.vue?vue&type=script&lang=ts"

import "./Testing.vue?vue&type=style&index=0&id=19722a44&scoped=true&lang=css"
import "./Testing.vue?vue&type=style&index=1&id=19722a44&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19722a44"]])

export default __exports__